<template>
<div class="form-row pfm-switch" :class="{'selected': cart.delivery.code == shipping.code}" @click="select">
  <div class="shipping-header header" v-if="isMore">
    <div class='radio-wrap'>
      <label for="provoni" class="multiple-lines radio-label">
        <span class='title'>{{shipping.name[lang]}}</span>
        <span class="delivery-place">pouze po Praze</span>
      </label>
      <span class="module-price" v-if="shopData.methodPrices">{{price}}</span>

    </div>
  </div>
</div>
</template>

<script>
import Cart from '@/cart'

export default {
  props: {
    cart: Object,
    isMore: Boolean,
    shipping: Object
  },
  components: {},
  data() {
    return {
      lang: Cart.lang,
      shopData: Cart.shopData,
      methodPrices: Cart.shopData.methodPrices,
      price: '...'
    }
  },
  created() {
    console.log('DeliveryInfoPanel::created', this.delivery)
    this.fillPrice()
  },
  watch: {
    methodPrices: {
      deep: true,
      handler() {
        this.fillPrice()
      }
    }
  },
  methods: {
    select() {
      this.$emit('click')
    },
    fillPrice() {
      if (Cart.shopData.methodPrices) {
        let code = this.shipping.subCode ? this.shipping.code + '-' + this.shipping.subCode : this.shipping.code
        let priceMinMax = Cart.shopData.methodPrices[code]
        this.price = priceMinMax ? (priceMinMax.n != priceMinMax.x ? priceMinMax.n + ' - ' + priceMinMax.x : priceMinMax.n) + ' Kč' : '-'
      } else {
        this.price = '...'
      }
    }
  }
}
</script>

<style scoped>
</style>
